import { supportedComponentNames } from 'app/model/expressCustomSetup/componentSetup';
import { ISelectOption } from 'app/interfaces/ISelectOption';


export function getComponentNameOptions(): Array<ISelectOption<string>> {
    const options: Array<ISelectOption<string>> = [
        {
            label: stringResources.Select,
            value: undefined
        }
    ];
    options.push({
        label: stringResources.IRCreation_SSIS_CustomSetup_Install_ComponentName_TaskFactory,
        value: supportedComponentNames.TaskFactory
    });
    options.push({
        label: stringResources.IRCreation_SSIS_CustomSetup_Install_ComponentName_HeddaIO,
        value: supportedComponentNames.HeddaIO
    },
        {
            label: stringResources.IRCreation_SSIS_CustomSetup_Install_ComponentName_SQLPhoneticsNet,
            value: supportedComponentNames.SqlPhoneticsNet
        });
    options.push({
        label: stringResources.IRCreation_SSIS_CustomSetup_Install_ComponentName_IntegrationToolkit,
        value: supportedComponentNames.IntegrationToolkit
    },
        {
            label: stringResources.IRCreation_SSIS_CustomSetup_Install_ComponentName_ProductivityPack,
            value: supportedComponentNames.ProductivityPack
        });
    options.push({
        label: stringResources.IRCreation_SSIS_CustomSetup_Install_ComponentName_XtractIS,
        value: supportedComponentNames.XtractIS
    });
    options.push({
        label: stringResources.IRCreation_SSIS_CustomSetup_Install_ComponentName_AsIntegrationService,
        value: supportedComponentNames.AsIntegrationService
    });
    options.push({
        label: stringResources.IRCreation_SSIS_CustomSetup_Install_ComponentName_CDataStandard,
        value: supportedComponentNames.CDataStandard
    },
        {
            label: stringResources.IRCreation_SSIS_CustomSetup_Install_ComponentName_CDataExtended,
            value: supportedComponentNames.CDataExtended
        },
        {
            label: stringResources.IRCreation_SSIS_CustomSetup_Install_ComponentName_CDataCloud,
            value: supportedComponentNames.CDataCloud
        });
        return options;
}

export function isAvailableComponent(componentName: string): boolean {
    const options: Array<ISelectOption<string>> = getComponentNameOptions();
    return options.some((opt) => opt.value === componentName);
}

export function getIRTypeDisplayName(type: string) {
    return type === 'VNETGateway'
        ? stringResources.Monitoring_CopyActivity_VirtualNetworkDataGateways
        : type === 'SelfHosted'
            ? stringResources.Monitoring_CopyActivity_OnPremisesDataGateways
            : '';
}
